<div *ngIf="isView" class="d-flex ratings-container" [ngClass]="!isArabic ? 'flex-row-reverse' : 'flex-row'">
	<ng-container *ngIf="assessmentRatings">
		<div *ngIf="assessmentRatings.RIR" class="d-flex rating"
			[ngClass]="!isArabic ? 'flex-row' : 'flex-row-reverse'">
			<div><img alt="CE" class="rating-icon" src="../../../../assets/images/RR.png"></div>
			<div class="rating-text-container">
				<div *ngIf="!isArabic" class="rating-header">Residual Impact Rating</div>
				<div *ngIf="isArabic" class="rating-header">تقييم الأثر المتبقي</div>
				<div class="rating-text " [ngClass]="!isArabic ? 'text-right' : 'text-left'">{{assessmentRatings.RIR}}
				</div>
			</div>
		</div>
		<div *ngIf="assessmentRatings.RLR" class="d-flex rating"
			[ngClass]="!isArabic ? 'flex-row' : 'flex-row-reverse'">
			<div><img alt="CE" class="rating-icon" src="../../../../assets/images/RR.png"></div>
			<div class="rating-text-container">
				<div *ngIf="!isArabic" class="rating-header">Residual Likelihood Rating</div>
				<div *ngIf="isArabic" class="rating-header">تقييم الاحتمالية المتبقية</div>
				<div class="rating-text " [ngClass]="!isArabic ? 'text-right' : 'text-left'">{{assessmentRatings.RLR}}
				</div>
			</div>
		</div>
		<div *ngIf="assessmentRatings.CE" class="d-flex rating" [ngClass]="!isArabic ? 'flex-row' : 'flex-row-reverse'">
			<div><img alt="CE" class="rating-icon" src="../../../../assets/images/CE.png"></div>
			<div class="rating-text-container">
				<div *ngIf="!isArabic" class="rating-header">Total Control Effectiveness Rating</div>
				<div *ngIf="isArabic" class="rating-header">تقييم فعالية التحكم الكلي</div>
				<div class="rating-text " [ngClass]="!isArabic ? 'text-right' : 'text-left'">{{assessmentRatings.CE}}
				</div>
			</div>
		</div>
		<div *ngIf="assessmentRatings.IR" class="d-flex rating" [ngClass]="!isArabic ? 'flex-row' : 'flex-row-reverse'">
			<div><img alt="IR" class="rating-icon" src="../../../../assets/images/IR.png"></div>
			<div class="rating-text-container">
				<div *ngIf="!isArabic" class="rating-header">Total Inherent Risk Rating</div>
				<div *ngIf="isArabic" class="rating-header">تصنيف إجمالي المخاطر المتأصلة</div>
				<div class="rating-text " [ngClass]="!isArabic ? 'text-right' : 'text-left'">{{assessmentRatings.IR}}
				</div>
			</div>
		</div>
		<div *ngIf="assessmentRatings.AO" class="d-flex rating" [ngClass]="!isArabic ? 'flex-row' : 'flex-row-reverse'">
			<div><img alt="AO" class="rating-icon" src="../../../../assets/images/IR.png"></div>
			<div class="rating-text-container">
				<div *ngIf="!isArabic" class="rating-header">Assessment Outcome</div>
				<div *ngIf="isArabic" class="rating-header">تصنيف إجمالي المخاطر المتأصلة</div>
				<div class="rating-text " [ngClass]="!isArabic ? 'text-right' : 'text-left'">{{assessmentRatings.AO}}
				</div>
			</div>
		</div>
	</ng-container>
</div>

<nav class="dashboardTabs" [ngClass]="isArabic ? 'arabicAlign' : ''">
	<div class="nav nav-tabs" id="nav-tab" role="tablist" [ngClass]="isArabic ? 'arabicNav' : ''">
		<!--button if and disabled condition previous 
			*ngIf="(isResubmit && questionnaireType == 'General') || !isResubmit"
			[disabled]="isResubmit && questionnaireType == 'General'"
		 -->
		<button *ngIf="showGeneralSection" class="nav-link" [ngClass]="questionnaireType == 'General' ? 'active' : ''"
			id="nav-general-tab" data-bs-toggle="tab" data-bs-target="#nav-general" type="button" role="tab"
			aria-controls="nav-execution" aria-selected="true" (click)="switchQuestionnaire('General')">
			<!-- <span *ngIf="isArabic">الاستبيان العام</span><span *ngIf="!isArabic">General Questionnaire</span> -->
			<span *ngIf="isArabic">القسم 1</span><span *ngIf="!isArabic">Section 1</span>
			<div class="quesCount" *ngIf="generalCount && !isResubmit && !isView">{{generalCount}}</div>
		</button>

		<button *ngIf="showInherentSection" class="nav-link"
			[ngClass]="questionnaireType == 'Inherent Risk' ? 'active' : ''" id="nav-inherent-tab" data-bs-toggle="tab"
			data-bs-target="#nav-inherent" type="button" role="tab" aria-controls="nav-inherent" aria-selected="false"
			(click)="switchQuestionnaire('Inherent Risk')">
			<!-- <span *ngIf="isArabic">استبيان المخاطر الكامنة</span><span *ngIf="!isArabic">Inherent Risk Questionnaire</span> -->
			<span *ngIf="isArabic">القسم 2</span><span *ngIf="!isArabic">Section 2</span>
			<div class="quesCount" *ngIf="inherentCount && !isResubmit && !isView">{{inherentCount}}</div>
		</button>

		<button *ngIf="showControlSection" class="nav-link" [ngClass]="questionnaireType == 'Controls' ? 'active' : ''"
			id="nav-control-tab" data-bs-toggle="tab" data-bs-target="#nav-control" type="button" role="tab"
			aria-controls="nav-control" aria-selected="false" (click)="switchQuestionnaire('Controls')">
			<!-- <span *ngIf="isArabic">استبيان الرقابة</span><span *ngIf="!isArabic">Control Questionnaire</span> -->
			<span *ngIf="isArabic">القسم 3</span><span *ngIf="!isArabic">Section 3</span>
			<div class="quesCount" *ngIf="controlCount && !isResubmit && !isView">{{controlCount}}</div>
		</button>



		<button *ngIf="!isView" class="nav-link  w-auto" [ngClass]="isArabic ? 'mr-auto ml-0' : 'ml-auto mr-0'"
			id="nav-unanswered-tab" data-bs-toggle="tab" data-bs-target="#nav-unanswered" type="button" role="tab"
			aria-controls="nav-unanswered" aria-selected="false" (click)="navigateToUnansweredQues()">
			<!-- <span *ngIf="isArabic">استبيان الرقابة</span><span *ngIf="!isArabic">Control Questionnaire</span> -->
			<ng-container *ngIf="!isResubmit && !isChecker">
				<span *ngIf="!isArabic">View Unanswered Questions</span>
				<span *ngIf="isArabic">عرض الأسئلة غير المجابة</span>
			</ng-container>
			<ng-container *ngIf="!isResubmit && isChecker">
				<span *ngIf="!isArabic">View Not-Reviewed Questions</span>
				<span *ngIf="isArabic">عرض الأسئلة التي لم تتم مراجعتها</span>
			</ng-container>
			<ng-container *ngIf="isResubmit">
				<span *ngIf="!isArabic">View Not-Resubmitted Questions</span>
				<span *ngIf="isArabic">عرض الأسئلة التي لم يتم إعادة إرسالها</span>
			</ng-container>
		</button>

	</div>
</nav>